import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import { RoleType } from '../../pages/admin/RoleManagement';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import AxiosConfig from '../../utilities/AxiosConfig';
import FormControl from 'react-bootstrap/FormControl';
import { qsStringify } from '../../utilities/helper';
import Dialog from '../../utilities/Dialog';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import { Form } from 'react-bootstrap';

interface RoleRow{
    role : RoleType;
    deleteCB : () => void;
    index : number;
    editCB : (index : number, edits : RoleType) => void;
};
//r-18-lint-dj
//eslint-disable-next-line
const RoleRow: React.FC<RoleRow>= (props : RoleRow) => {
    const [editing, setEditing] = React.useState(false);
    const [edits, setEdits] = React.useState({...props.role});
    const [sendingEdits, setSendingEdits] = React.useState(false);
    const { role } = props;

    const deleteRole = async () => {
        let c: any = new Dialog({ message: `Are you sure you want to delete ${role.RoleName} Role?` });
        let answer: boolean = await c.show();
        if(answer){
            let myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("authorization", AxiosConfig.configValue().headers.authorization);
            let urlencoded = new URLSearchParams();
            urlencoded.append("RoleName", props.role.RoleName);

            let requestOptions = {
                method: 'DELETE',
                headers: myHeaders,
                body: urlencoded,
            };

            fetch(process.env.REACT_APP_API_URL + "/api/portal/role", requestOptions)
            .then(response => response.text())
            .then(result => {
                //console.log(result);
                props.deleteCB();
                // callback function to actually remove role
            })
            .catch(error => {
                //console.log('error', error);
                alert("There was an error deleting that role");
                AxiosConfig.handleError(error);
            });
        }
    }

    const toggleEdit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setEditing(!editing);
    }

    const handleEditsChange = (e: React.ChangeEvent<HTMLInputElement>):void => {
        //handle edits here
        // e.preventDefault();
        if(e.target.type === "checkbox"){
            setEdits({...edits, [e.target.name] : !edits.IsProtected});
        }else{
            setEdits({...edits, [e.target.name] : e.target.value});
        }
    }

    const handleEditSubmit = (e: React.SyntheticEvent) => {
        //submit edits here
        e.preventDefault();
        setSendingEdits(true);
        const config = AxiosConfig.configValue();
        const requestBody = qsStringify({...role, ...edits});
        axios.post(process.env.REACT_APP_API_URL + '/api/portal/role', requestBody, config)
        .then(res => {
            if(res.data){
                //console.log(res, res.data)
                setEditing(false);
                setEdits(role);
                props.editCB(props.index, {...role, ...edits});
            }
        })
        .catch(err => {
            //console.log(err.response);
            alert("There was an error updating role.");
            AxiosConfig.handleError(err);
        })  
        .finally(() => {
            setSendingEdits(false);
        })
    }

    return(
        <tr>
            <td>{role.PortalRoleId}</td>
            <td>
                { role.RoleName }
            </td>
            <td data-tip data-for={`tooltip-${role.PortalRoleId}`}>
                {
                editing 
                ? <FormControl onChange={handleEditsChange} name="Description" type="text" value={edits.Description} /> 
                :
                role.Description && role.Description.length > 50 
                    ? <>
                    {role.Description.substring(0, 50)}...
                    <ReactTooltip 
                        id={`tooltip-${role.PortalRoleId}`}
                        type="dark"
                        place="bottom"
                        className="table-tooltip"
                    >
                        {role.Description}
                    </ReactTooltip>
                    </>
                : 
                `${role.Description}`
                }
            </td>
            <td>
                {
                editing 
                ?<FormControl onChange={handleEditsChange} name="RoleCategory" type="text" value={edits.RoleCategory} /> 
                :role.RoleCategory
                }
            </td>
            <td>
                {
                    editing
                    ?
                    <Form.Check label="Protected" checked={edits.IsProtected} onChange={handleEditsChange} name="IsProtected"/>
                    :<i className="material-icons">{role.IsProtected ? "done" : "close"}</i>
                }
            </td>
            <td>{role.CreatedDate}</td>
            <td>{role.CreatedBy}</td>
            <td>{role.ModifyDate}</td>
            <td>{role.ModifiedBy}</td>
            <td>
                <ButtonGroup className="d-flex flex-row justify-content-end">
                    {
                    editing
                        ?
                        <>
                        <Button className="flex-0" onClick={handleEditSubmit} disabled={sendingEdits}>
                            {
                                sendingEdits
                                ?<Spinner size="sm" role="status" as="span" animation="border" />
                                :<i className="material-icons">save</i>
                            }
                        </Button>
                        <Button className="flex-0" onClick={toggleEdit} variant="danger">
                            <i className="material-icons">cancel</i>
                        </Button>
                        </>
                        :
                        <>
                        <Button className="flex-0" onClick={toggleEdit}>
                            <i className="material-icons">edit</i>
                        </Button>
                        <Button className="flex-0" onClick={deleteRole} variant="danger">
                            <i className="material-icons">delete</i>
                        </Button>
                        </>
                    }
                </ButtonGroup>
            </td>
        </tr>
    )
}

export default RoleRow;